// extracted by mini-css-extract-plugin
export default {"cls1":"CookieConsent-Banner_cls1__vQS8l","cls2":"CookieConsent-Banner_cls2__xImXI CookieConsent-Banner_cls1__vQS8l"};